<template>
  <v-container>

      <!-- <input type="file" ref="barcodeCamera" accept="image/*" capture="camera" class="hidden" @change="onScanBarcode">

      <v-btn color="primary" class="mr-4" @click="$refs.barcodeCamera.click()">
        <v-icon left>mdi-barcode</v-icon>
          Scan Barcode
        </v-btn> -->
      <img v-if="image != null" ref="image" :src="image" width="auto" height="200px" @load="imageLoaded"/>
      <img v-if="imageScaled != null" :src="imageScaled" width="auto" height="auto" />
      <input type="file" ref="pictureFile" accept="image/*" class="hidden"  @change="onSelectImage">
      <input type="file" ref="pictureCamera" accept="image/*" capture="camera" class="hidden" @change="onSelectImage">
      <v-btn color="primary" class="mr-4" @click="$refs.pictureCamera.click()">
        <v-icon left>mdi-camera</v-icon>
        Take Picture
      </v-btn>

      <v-btn color="primary" class="mr-4" @click="$refs.pictureFile.click()">
        <v-icon left>mdi-file</v-icon>
        Select Picture
      </v-btn>

      <v-text-field v-model="barcode" label="Barcode"></v-text-field>

  </v-container>
</template>

<script>

export default {
  name: 'Test',
  data: () => ({
    image: null,
    imageScaled: null,
    imagefile: null,
    barcode: null,
  }),
  mounted() {
    console.log('mounted');
  },
  methods: {
    onSelectImage(e) {
      const files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      this.imagefile = files[0];
      const reader = new FileReader();
      reader.readAsDataURL(this.imagefile);
      reader.onload = (f) => {
        this.image = f.target.result;
      };
    },
    uploadImage() {
      const data = {
        image: this.imageScaled,
      };

      this.$webConn.request('app2_scan_barcode', data).then((result) => {
        this.barcode = result.barcode;
        console.log(result);
      }).catch((error) => {
        alert(error.Message);
      });
    },
    imageLoaded(e) {
      const img = e.target;
      const width = 700;
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      // -- canvas scaling --
      const start = window.performance.now();

      canvas.width = width;
      canvas.height = canvas.width * (img.height / img.width);
      ctx.filter = 'contrast(1.5) brightness(1.5) grayscale(100%)';
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

      let data = canvas.toDataURL('image/webp', 0.5); // webp seems to compress very good
      if (data.substring(0, 15) !== 'data:image/webp') { // webp not supported fallback to jpg
        data = canvas.toDataURL('image/jpeg', 0.8);
      }
      this.imageScaled = data;
      this.uploadImage();
    },
    // contrastImage(imageData, contrast) {
    //   const data = imageData.data;
    //   const factor = (259 * (contrast + 255)) / (255 * (259 - contrast));

    //   for (let i = 0; i < data.length; i += 4) {
    //     data[i] = factor * (data[i] - 128) + 128;
    //     data[i + 1] = factor * (data[i + 1] - 128) + 128;
    //     data[i + 2] = factor * (data[i + 2] - 128) + 128;
    //   }
    //   return imageData;
    // },
  },
};
</script>
